import {texture} from "p3";
import NPC from "./NPC";
import definitions from "../../../definitions";

export default class NPCGiantSpider extends NPC {
    constructor() {
        super(definitions.NPC_ID.GIANT_SPIDER);

        this.collisionRadius = 20;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_giant_spider_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(0, 0));
        this.animateIdle(1);
    }

    onViewAdded() {
        super.onViewAdded();

        this.status.x += 86;
        this.status.y += 210;
    }
}